/* eslint-disable no-console */
export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["OFF"] = 0] = "OFF";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["INFO"] = 3] = "INFO";
    LogLevel[LogLevel["DEBUG"] = 4] = "DEBUG";
})(LogLevel || (LogLevel = {}));
export class Logger {
    logLevel;
    constructor(logLevel) {
        this.logLevel = logLevel;
    }
    shouldLog(level) {
        return this.logLevel > LogLevel.OFF && level <= this.logLevel;
    }
    info(...args) {
        if (this.shouldLog(LogLevel.INFO)) {
            console.log('[INFO]:', ...args);
        }
    }
    debug(...args) {
        if (this.shouldLog(LogLevel.DEBUG)) {
            console.log('[DEBUG]:', ...args);
        }
    }
    warn(...args) {
        if (this.shouldLog(LogLevel.WARN)) {
            console.warn('[WARN]:', ...args);
        }
    }
    error(...args) {
        if (this.shouldLog(LogLevel.ERROR)) {
            console.error('[ERROR]:', ...args);
        }
    }
}
//# sourceMappingURL=logger.utils.js.map